<header role="banner" class="content__header">
    <div class="menu-btn">
        <div class="menu-btn__outline">
            <app-button
                    [ariaLabel]="('SCREEN_READER.HEADER.MENU_EDUCATION_BUTTON' | translate) + ('GENERAL.BUTTON' | translate)"
                    [cssClasses]="'solid__blue-02 half-rounded__right wh-72'"
                    [iconColor]="'blue-10'"
                    [icon]="'menu'"
                    [active]="activeOutlineTab === 1"
                    (buttonClicked)="openMenu('OUTLINE')">
            </app-button>
        </div>
        <div class="menu-btn__comments" *ngIf="enableCommenting || reviewerMode">
            <app-button
                    [ariaLabel]="('SCREEN_READER.HEADER.MENU_COMMENT_BUTTON' | translate) + comments?.length.toString() + ('GENERAL.COMMENTS' | translate)"
                    [cssClasses]="'solid__blue-02 half-rounded__right wh-72'"
                    [icon]="'chat_bubble'"
                    [iconColor]="'blue-10'"
                    [overIconText]="comments?.length.toString()"
                    [active]="activeOutlineTab === 2"
                    (buttonClicked)="openMenu('COMMENTS')">
            </app-button>
        </div>
        <div class="menu-btn__settings" *ngIf="enableSettings">
            <app-button
                    [ariaLabel]="'SCREEN_READER.HEADER.MENU_SETTINGS_BUTTON' | translate"
                    [cssClasses]="'solid__blue-02 half-rounded__right wh-72'"
                    [icon]="'settings'"
                    [iconColor]="'blue-10'"
                    [active]="activeOutlineTab === 3"
                    (buttonClicked)="openMenu('SETTINGS')">
            </app-button>
        </div>
    </div>
    <div class="content-header-inner">
        <div class="header-info">
            <div class="header-info__back-link">
                <app-button *ngIf="showBackButton"
                            [ariaLabel]="('SCREEN_READER.HEADER.BACK_BUTTON' | translate) + backButtonText + ('GENERAL.BUTTON' | translate)"
                            [cssClasses]="'btn slim solid__blue-02'"
                            [icon]="'arrow_back'"
                            [hideLabelMobileOnly]="true"
                            (buttonClicked)="getBack()">
                    {{backButtonText}}
                </app-button>
            </div>
            <p class="header-info__chapter-title">{{ indicationTitle }}</p>
            <h1 class="header-info__unit-title"></h1>
        </div>
        <div class="header-controls" *ngIf="showHeaderControls">
            <div class="header-user-box">
                <div class="btn-wrapper">
                    <app-button
                            [cssClasses]="'btn slim solid__gray-02'"
                            [icon]="'logout'"
                            [hideLabelMobileOnly]="true"
                            [ariaLabel]="('GENERAL.LEAVE' | translate) + ('GENERAL.BUTTON' | translate)"
                            (buttonClicked)="leaveIndication.emit()">
                        {{'GENERAL.LEAVE' | translate}}
                    </app-button>
                </div>
            </div>
            <div class="header-tts-buttons">
                <div class="header-controls__play">
                    <app-button
                            [ariaLabel]="((ttsIconState === playState ? 'SCREEN_READER.HEADER.PLAY_BUTTON' : 'SCREEN_READER.HEADER.PAUSE_BUTTON') | translate) + ('GENERAL.BUTTON' | translate)"
                            [cssClasses]="'solid__blue-08 circle wh-80'"
                            [iconState]="ttsIconState"
                            (buttonClicked)="readText()">
                    </app-button>
                </div>
                <div class="header-controls__repeat">
                    <app-button
                            [ariaLabel]="('SCREEN_READER.HEADER.REPEAT_BUTTON' | translate) + ('GENERAL.BUTTON' | translate)"
                            [cssClasses]="'solid__blue-02 circle wh-60'"
                            [icon]="'replay'"
                            [iconColor]="'blue-10'"
                            [disabled]="repeatButtonDisabled"
                            (buttonClicked)="playFromStart()">
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</header>
